import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';

const PerformanceManagement = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    listBySchool: async (
      schoolId: string,
      filteredOptions?: FilteredOptionsInterface,
      period?: { startDate?: string; endDate?: string },
    ) => {
      const params: any = makeQueryParamsForRequest(filteredOptions);

      if (period?.startDate) {
        params.startDate = period.startDate;
      }

      if (period?.endDate) {
        params.endDate = period.endDate;
      }

      const result = await http.get(`/performance-management/by-school/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    getPendingBySchool: async (schoolId: string) => {
      const result = await http.get(`/performance-management/by-school/${schoolId}/pending`, {
        headers,
      });
      return result.data;
    },
    getDisciplineCountsByEmployee: async (employeeId: string) => {
      const result = await http.get(`/performance-management/discipline-counts/by-employee/${employeeId}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default PerformanceManagement;
